export const option = {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchMenuSpan: 6,
  border: true,
  index: false,
  viewBtn: false,
  editBtn:false,
  delBtn:false,
  addBtn: false,
  labelWidth: 120,
  selection: false,
  menu: false,
  // header: false,
  columnBtn: false,
  dialogClickModal: false,
  column: [
    {
      label: "月份",
      prop: "month",
      minWidth: 120
    },

    {
      label: "放款总额(万元)",
      prop: "lendingTotal",
      minWidth: 120,
      formatter: (row, value) => {
        if (isNaN(value * 1)) return '/'
        return `${(value * 1).toFixed(2)}`
      }
    },
    {
      label: "业绩总额(万元)",
      prop: "quarterTotal",
      minWidth: 120,
      formatter: (row, value) => {
        if (isNaN(value * 1)) return '/'
        return `${(value * 1).toFixed(2)}`
      }
    },
    {
      label: "目标(万元)",
      prop: "quarterTarget",
      minWidth: 120,
      formatter: (row, value) => {
        if (isNaN(value * 1)) return '/'
        return `${(value * 1).toFixed(2)}`
      }
    },
    {
      label: "月度放款完成率",
      prop: "monthLendingCompletionRate",
      minWidth: 120,
      formatter: (row, value) => {
        if (isNaN(value * 1)) return '/'
        return `${(value * 100).toFixed(2)}%`
      }
    },
    {
      label: "月度业绩完成率",
      prop: "monthTartetCompletionRate",
      minWidth: 120,
      formatter: (row, value) => {
        if (isNaN(value * 1)) return '/'
        return `${(value * 100).toFixed(2)}%`
      }
    },
    {
      label: "季度放款完成率",
      prop: "quarterLendingCompletionRate",
      minWidth: 120,
      formatter: (row, value) => {
        if (isNaN(value * 1)) return '/'
        return `${(value * 100).toFixed(2)}%`
      }
    },
    {
      label: "季度业绩完成率",
      prop: "quarterTartetCompletionRate",
      minWidth: 120,
      formatter: (row, value) => {
        if (isNaN(value * 1)) return '/'
        return `${(value * 100).toFixed(2)}%`
      }
    },
    {
      label: "年度放款完成率",
      prop: "yearLendingCompletionRate",
      minWidth: 120,
      formatter: (row, value) => {
        if (isNaN(value * 1)) return '/'
        return `${(value * 100).toFixed(2)}%`
      }
    },
    {
      label: "年度业绩完成率",
      prop: "yearTartetCompletionRate",
      minWidth: 120,
      formatter: (row, value) => {
        if (isNaN(value * 1)) return '/'
        return `${(value * 100).toFixed(2)}%`
      }
    },
  ],
};
